module.exports = require("core-js/library/fn/number/is-integer");


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime-corejs2@7.9.2@@babel/runtime-corejs2/core-js/number/is-integer.js
// module id = 2483
// module chunks = 0